export const ECO_BLOCK_ICONS = {
  co2: 'ILLUSTRATION-CO2_S_Dark',
  'e-waste': 'ILLUSTRATION-Mouse_S_Dark',
  'raw-materials': 'ILLUSTRATION-Rock_M_Dark',
  water: 'ILLUSTRATION-Waterdrop_M_Dark',
}
